
export const customerServicePath = 'chat/working-hours';
export const getWorkingHours = `${customerServicePath}/standard-hours`;
